import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-03',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-03.component.html',
  styleUrls: []
})
export class Article03Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'O que é lance mínimo em leilão de imóvel? | Casato Brasil',
    description: 'Saiba o que é lance mínimo em leilão de imóvel, como ele funciona nas diferentes etapas do leilão e por que esse valor é decisivo para planejar sua compra.'
  };
}
